// API URL helper - supports custom domains (acountix.eu) via relative URLs
// When frontend domain matches REACT_APP_BACKEND_URL, use that (preview env)
// When on custom domain, use relative URLs to avoid cross-origin cookie issues
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

function getApiUrl() {
  if (typeof window === 'undefined') return envUrl;
  
  // If current origin matches the configured backend URL, use it directly
  if (envUrl && window.location.origin === envUrl) {
    return envUrl;
  }
  
  // On custom domains (e.g. acountix.eu), use relative URLs
  // The ingress routes /api/* to the backend regardless of domain
  return '';
}

export const API_URL = getApiUrl();
